const brandColor = {
  skb: {
    mainColor: '#13BF80',
    mainColorRgba: '19,191,128',
  },
  jbcgk: {
    mainColor: '#E60003',
    mainColorRgba: '230,0,3',
  },
  jbcshangan: {
    mainColor: '#E60003',
    mainColorRgba: '230,0,3',
  },
  gpjs: {
    mainColor: '#FF6A4D',
    mainColorRgba: '255,106,77',
  },
  xuandiao: {
    mainColor: '#E90003',
    mainColorRgba: '233,0,3',
  },
  jbczsb: {
    mainColor: '#007EF9',
    mainColorRgba: '0,126,249',
  },
  jbczsb: {
    mainColor: '#007EF9',
    mainColorRgba: '0,126,249',
  },
  jbcyk: {
    mainColor: '#1F5ECC',
    mainColorRgba: '31, 94, 204',
  },
}
module.exports = brandColor
